/* Shopify owns rates and totals. This module only estimates shipping; it never changes markets or checkout navigation. */
(function () {
  'use strict';
  if (window.clyroCartShipping) return;
  var queue = Promise.resolve();
  var geoPromise;
  function request(url, options, timeoutMs) {
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, timeoutMs || 10000);
    return window.fetch(url, Object.assign({credentials:'same-origin', cache:'no-store', signal:controller.signal}, options || {}))
      .then(function (r) { if (!r.ok) throw new Error('rate-request'); return r; })
      .finally(function () { window.clearTimeout(timeout); });
  }
  function delay(ms) { return new Promise(function (done) { window.setTimeout(done, ms); }); }
  function signature(cart) {
    return JSON.stringify([cart.currency, cart.total_price, cart.original_total_price, cart.total_weight,
      cart.items.map(function (i) { return [i.key,i.quantity,i.final_line_price,i.requires_shipping,i.grams]; }),
      cart.cart_level_discount_applications, cart.discount_codes]);
  }
  window.clyroCartShipping = function (root) {
    var host = root.querySelector('[data-cs]');
    if (!host) return null;
    var config = JSON.parse(host.querySelector('[data-cs-config]').textContent);
    var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var country = host.querySelector('[data-cs-country]');
    var province = host.querySelector('[data-cs-province]');
    var provinceWrap = host.querySelector('[data-cs-province-wrap]');
    var zip = host.querySelector('[data-cs-zip]');
    var form = host.querySelector('[data-cs-form]');
    var change = host.querySelector('[data-cs-change]');
    var ratesSelect = host.querySelector('[data-cs-rates]');
    var status = host.querySelector('[data-cs-status]');
    var details = host.querySelector('[data-cs-details]');
    var detailsLabel = host.querySelector('[data-cs-details-label]');
    var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 639px)') : null;
    var desktopQuery = window.matchMedia ? window.matchMedia('(min-width: 640px)') : null;
    var button = root.querySelector('[data-cd-button-label]');
    var buttonBase = button ? button.textContent : '';
    var lastButton = '';
    var cart, currentKey='', destination=null, rates=[], selected=null, timer, generation=0;
    var destroyed=false, opened=false, busy=false, state='idle', rateAt=0;
    function updateDisclosureLabel() {
      if (detailsLabel && details) detailsLabel.textContent = details.open ? config.breakdownOpenLabel : config.breakdownClosedLabel;
    }
    function syncDisclosure() {
      if (!details) return;
      var shouldCollapse = (config.collapseMobile && mobileQuery && mobileQuery.matches) ||
        (config.collapseDesktop && desktopQuery && desktopQuery.matches);
      details.open = !shouldCollapse;
      updateDisclosureLabel();
    }
    function onDisclosureToggle() { updateDisclosureLabel(); }
    var storageKey='clyro:shipping-destination:v1';
    try { var saved=JSON.parse(window.sessionStorage.getItem(storageKey));
      if (saved && saved.at > Date.now()-86400000 && saved.country && countryOption(saved.country)) destination=saved;
    } catch (_) {}
    function money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:cart.currency || config.currency,
        currencyDisplay:config.currencyStyle || 'code'}).format(cents / 100);
    }
    function put(key,value) { var n=host.querySelector('[data-cs-'+key+']'); if(n) n.textContent=value; }
    function countryOption(code) { return Array.prototype.find.call(country.options,function(o){return o.value===code || o.textContent===code;}); }
    function provinces() {
      var option=country.options[country.selectedIndex];
      var list=[];
      try { list=JSON.parse(option.getAttribute('data-provinces') || '[]'); } catch (_) {}
      province.replaceChildren();
      var blank=document.createElement('option'); blank.value='';blank.textContent=config.chooseRegion;province.appendChild(blank);
      list.forEach(function(p){var o=document.createElement('option');o.value=p[0];o.textContent=p[1];province.appendChild(o);});
      provinceWrap.hidden=!list.length;
    }
    function fillForm() {
      if(destination) country.value=destination.country;
      provinces();province.value=destination && destination.province || '';zip.value=destination && destination.zip || '';
    }
    function updateButton(total) {
      if(!button) return;
      if(button.textContent !== lastButton) buttonBase=button.textContent;
      lastButton=buttonBase + (config.checkoutAmount && total !== null ? ' '+config.checkoutSeparator+' '+money(total) : '');
      button.textContent=lastButton;
    }
    function draw() {
      if(destroyed || !cart) return;
      var subtotal=Number(cart.total_price)||0;
      var savings=Math.max(0,(Number(cart.original_total_price)||subtotal)-subtotal);
      var shipping=selected ? selected.cents : null;
      var total=shipping === null ? null : subtotal+shipping;
      put('subtotal',money(config.subtotalMode==='original' ? subtotal+savings : subtotal));
      put('discount',savings ? '−'+money(savings) : money(0));
      var discountRow=host.querySelector('[data-cs-discount-row]');
      discountRow.hidden=!config.showDiscount || (!savings && !config.zeroDiscount);
      put('shipping',shipping === null ? config.pendingAmount : (shipping===0 ? config.freeLabel : money(shipping)));
      put('total',total===null ? config.pendingAmount : money(total));
      var option=destination && countryOption(destination.country);
      put('destination',destination ? [option ? option.textContent : destination.country,destination.province,destination.zip].filter(Boolean).join(', ') : config.detecting);
      put('source',destination ? (destination.source==='geo' ? config.detectedLabel : destination.source==='manual' ? config.selectedLabel : config.defaultLabel) : '');
      var messages={idle:config.detecting,loading:config.loading,ready:config.estimateNote,empty:config.noRates,error:config.error,noShipping:config.noShipping};
      status.textContent=messages[state] || config.loading;
      host.setAttribute('aria-busy',state==='loading' ? 'true':'false');
      ratesSelect.hidden=!config.showServices || rates.length<2 || state!=='ready';
      put('service',config.showServiceName && selected && state==='ready' ? selected.name : '');
      updateButton(total);
    }
    function invalidate() { generation++;window.clearTimeout(timer);rates=[];selected=null;rateAt=0;state='loading';draw(); }
    function chooseRates(list) {
      rates=list.map(function(r){
        if (r.price === null || r.price === undefined || String(r.price).trim() === '') return null;
        var cents=Math.round(Number(r.price)*100);
        if(!Number.isFinite(cents) || cents<0 || (r.currency && r.currency!==cart.currency)) return null;
        return {name:String(r.name || ''),cents:cents};
      }).filter(Boolean).sort(function(a,b){return a.cents-b.cents;});
      selected=rates.find(function(r){return config.preferredRate && r.name===config.preferredRate;}) || rates[0] || null;
      ratesSelect.replaceChildren();
      rates.forEach(function(r,i){var o=document.createElement('option');o.value=String(i);o.textContent=r.name+' · '+(r.cents ? money(r.cents):config.freeLabel);o.selected=r===selected;ratesSelect.appendChild(o);});
      state=selected ? 'ready':'empty';rateAt=Date.now();draw();
    }
    function calculate() {
      if(destroyed || !opened || busy || !cart || !destination) return;
      if(!cart.items.some(function(i){return i.requires_shipping!==false;})) {
        selected={name:'',cents:0};state='noShipping';draw();return;
      }
      var token=generation;
      var address=Object.assign({},destination);
      var valid=function(){return !destroyed && opened && !busy && token===generation;};
      var params=new URLSearchParams();
      params.set('shipping_address[country]',address.country);
      params.set('shipping_address[province]',address.province || '');
      params.set('shipping_address[zip]',address.zip || '');
      // Shopify stores prepared quotes in the cart session. Serialize all drawer jobs.
      queue=queue.catch(function(){}).then(async function(){
        if(!valid()) return;
        var deadline=Date.now()+20000;
        try {
          await request(route+'cart/prepare_shipping_rates.json',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded','Accept':'application/json'},body:params.toString()});
          // The prepare response can be empty. Only the async endpoint contains rates.
          for(var attempt=0;attempt<8;attempt++) {
            if(!valid()) return;
            if(Date.now()>=deadline) throw new Error('rate-timeout');
            var response=await request(route+'cart/async_shipping_rates.json?'+params.toString(),{headers:{Accept:'application/json'}},Math.min(10000,deadline-Date.now()));
            var data=await response.json();
            if(!valid()) return;
            if(data && Array.isArray(data.shipping_rates)) { chooseRates(data.shipping_rates);return; }
            await delay(Math.min(500+attempt*250,1500));
          }
          throw new Error('rate-timeout');
        } catch (_) { if(valid()) {state='error';draw();} }
      });
    }
    async function detect() {
      if(destination) return;
      if(config.geo) {
        if(!geoPromise) geoPromise=request(route+'browsing_context_suggestions.json?country[enabled]=true').then(function(r){return r.json();}).catch(function(){return null;});
        var data=await geoPromise;
        var detected=data && data.detected_values && data.detected_values.country;
        var detectedName=detected && (detected.name || (config.countries || {})[detected.handle]);
        if(destroyed || destination) return;
        if(detectedName && countryOption(detectedName)) destination={country:countryOption(detectedName).value,province:'',zip:'',source:'geo'};
      }
      if(destroyed || destination) return;
      var fallback=countryOption(config.country);
      destination={country:fallback ? fallback.value : config.country,province:'',zip:'',source:'default'};
    }
    function schedule() {
      window.clearTimeout(timer);
      if(!opened || busy || !cart) return;
      timer=window.setTimeout(function(){
        var token=generation;
        detect().then(function(){if(!destroyed && token===generation && opened && !busy){draw();calculate();}});
      },350);
    }
    function update(data,isOpen,isBusy) {
      if(destroyed || !data) return;
      var wasOpen=opened, wasBusy=busy;
      opened=!!isOpen;busy=!!isBusy;cart=data;
      var key=signature(cart);
      var changed=key!==currentKey;
      currentKey=key;
      if(changed || (busy && !wasBusy) || (!opened && wasOpen) || (opened && !wasOpen && Date.now()-rateAt>60000)) invalidate();
      draw();
      if(opened && !busy && (changed || !wasOpen || wasBusy || state==='idle')) schedule();
    }
    function onChangeClick(){fillForm();form.hidden=!form.hidden;change.setAttribute('aria-expanded',String(!form.hidden));if(!form.hidden) country.focus();}
    function onCancel(){form.hidden=true;change.setAttribute('aria-expanded','false');change.focus();}
    function onSubmit(event){
      event.preventDefault();
      if(!country.value) return;
      destination={country:country.value,province:provinceWrap.hidden?'':province.value,zip:zip.value.trim().slice(0,20),source:'manual',at:Date.now()};
      try {window.sessionStorage.setItem(storageKey,JSON.stringify(destination));} catch (_) {}
      onCancel();invalidate();schedule();
    }
    function onRate(){selected=rates[Number(ratesSelect.value)] || null;draw();}
    if(details) details.addEventListener('toggle',onDisclosureToggle);
    if(mobileQuery) {
      if(mobileQuery.addEventListener) mobileQuery.addEventListener('change',syncDisclosure);
      else if(mobileQuery.addListener) mobileQuery.addListener(syncDisclosure);
    }
    if(desktopQuery) {
      if(desktopQuery.addEventListener) desktopQuery.addEventListener('change',syncDisclosure);
      else if(desktopQuery.addListener) desktopQuery.addListener(syncDisclosure);
    }
    syncDisclosure();
    change.addEventListener('click',onChangeClick);country.addEventListener('change',provinces);
    form.addEventListener('submit',onSubmit);ratesSelect.addEventListener('change',onRate);
    var cancel=host.querySelector('[data-cs-cancel]');cancel.addEventListener('click',onCancel);
    host.hidden=false;root.setAttribute('data-cd-shipping-enabled','true');
    return {update:update,destroy:function(){destroyed=true;generation++;window.clearTimeout(timer);change.removeEventListener('click',onChangeClick);country.removeEventListener('change',provinces);form.removeEventListener('submit',onSubmit);ratesSelect.removeEventListener('change',onRate);cancel.removeEventListener('click',onCancel);if(details)details.removeEventListener('toggle',onDisclosureToggle);[mobileQuery,desktopQuery].forEach(function(query){if(!query)return;if(query.removeEventListener)query.removeEventListener('change',syncDisclosure);else if(query.removeListener)query.removeListener(syncDisclosure);});root.removeAttribute('data-cd-shipping-enabled');host.hidden=true;if(button && button.textContent===lastButton)button.textContent=buttonBase;}};
  };
  document.dispatchEvent(new CustomEvent('clyro:shipping:ready'));
}());
